import DecisionAndReasoningComponentWithRejectedNotification from "src/components/review-decision-and-reasoning-with-error-identfication";
import { formatUtcDateToLocal, parseDate } from "../../../../../../common/utils/TimeUtils";
import { TextWithSubTitle } from "../../../../../../components/textWithSubTitle";
import {
  DecisionAndReasoningFilterDropdown,
  filterDecisionAndReasoningColumn,
} from "./decision-and-reasoning-filter-dropdown";
import UserForReviewTask from "src/components/user-for-review-task";

export function previewAndSubmitColumnGenerator(columns, filterReasons, getPopupContainer) {
  const editedColumns = columns?.slice(0).map((column, index) => {
    let { render, tableFilter, ...restKeys } = column;
    if (render === "TextWithSubTitleComponent") {
      render = (titles) => <TextWithSubTitle titles={titles} />;
      restKeys = {
        ...restKeys,
        width: 160,
        render,
      };
      if (index === 0) {
        restKeys.fixed = "left";
        restKeys.render = (userDetails)=><UserForReviewTask userDetails={userDetails}/>
      }
    }
    if (column.key === "reviewedAt") {
      render = (dateStr) => {
        if (dateStr === "") return dateStr;
        return formatUtcDateToLocal(parseDate(dateStr), "YYYY-MM-DD HH:mm:ss");
      };
      restKeys = {
        ...restKeys,
        className: `${restKeys.className} preview-table-reviewed-at`,
        render,
      };
    }
    if (render === "ReviewDecisionAndReasoningComponent") {
      render = (_text, record) => (
        <DecisionAndReasoningComponentWithRejectedNotification
          record={record}
          reviewStatus={false}
          selectedRowKeys={1}
          resetTask={null}
          removeEditedReviewTasks={null}
          upsertEditedReviewTasks={null}
          userDetails={null}
          handleClearSaved={null}
          calculatedDisabled={() => true}
          rejectedTaskReason={null}
          getPopupContainer={getPopupContainer}
        />
      );
      restKeys = {
        ...restKeys,
        fixed: "right",
        className: `${restKeys.className} ant-column`,
        width: 210,
        searchEnabled: false,
        sortEnabled: false,
        filters: [],
        filterEnabled: true,
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, visible }) => (
          <DecisionAndReasoningFilterDropdown
            selectedKeys={selectedKeys}
            setSelectedKeys={setSelectedKeys}
            confirm={confirm}
            decisionFilters={tableFilter}
            reasonsAvailableForFilter={filterReasons}
            visible={visible}
            getPopupContainer={getPopupContainer}
          />
        ),
        onFilter: filterDecisionAndReasoningColumn,
        render,
      };
    } else {
      restKeys = {
        ...restKeys,
        width: 180,
        sortWarningConfirmation:null,
      };
    }
    return restKeys;
  });

  const filteredColums = editedColumns.filter(({ key, title }) => {
    return key !== "ticket" && title !== "Delegation";
  });

  return filteredColums;
}
